import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { DefaultTypography } from "styled-components/native";
import tokens from "../../../vdb-tokens.json";
import {
  generateTypographyTokens,
  regenerateTypographyTokens,
} from "@utils/design-tokens";

let typography = generateTypographyTokens(tokens.global, tokens.global, {});
typography = regenerateTypographyTokens(typography) as DefaultTypography;

export const DEFAULT_TYPOGRAPHY: DefaultTypography = typography;

// TODO: Set the typography type when we have the typography properties defined
export const typographySlice = createSlice({
  name: "typography",
  initialState: DEFAULT_TYPOGRAPHY,
  reducers: {
    setTypography: (state, action) => {
      return {
        ...state,
        ...action.payload,
        // updatedTime: new Date().toISOString(),
      };
    },
  },
});

export const { setTypography } = typographySlice.actions;

// TODO: Add type when we define typographys
export const useTypographyStore = () =>
  useSelector((state: any) => state.typography);

export default typographySlice.reducer;
